<template>
  <main>
    <div data-scroll-el="pdpContainer" />
    <div class="container" :class="{ 'fit-finder-container': $feature.showFitFinderOnPDP }">
      <slot name="notifications" />
      <transition name="fade">
        <div v-if="productPending && !product">
          <slot name="skeletons" />
        </div>
        <div v-else-if="product">
          <slot name="breadcrumbs" />
          <div :class="brandClasses.grid">
            <!-- Product Heading Section -->
            <section :class="brandClasses.heading">
              <slot name="heading" />
              <slot name="klarna-payments" />
              <slot name="paypal-payments" />
            </section>
            <section
              :class="[
                brandClasses.gallery,
                { 'md:sticky': $feature.showFullscreenGridOnPDP },
              ]"
              :style="{ top: pxToRem(header.height.navigation) }"
            >
              <slot name="gallery" />
            </section>
            <section
              :class="brandClasses.details"
              :style="{ top: pxToRem(header.height.navigation) }"
            >
              <slot name="reviews-summary" />
              <slot name="variant-selection" />
              <slot name="espot-below-sizes" />
              <slot name="gift-card" />
              <p v-if="sizingMessage" class="mt-4 text-xs">
                {{ sizingMessage }}
              </p>
              <slot name="size-and-fit" />
              <slot name="espot-above-add-to-cart" />
              <slot name="ctas" />
              <slot name="upsells" />
              <slot name="shipping-methods" />
              <slot name="espot-above-accordions" />
              <slot name="accordions" />
              <slot name="espot-below-accordions" />
            </section>
          </div>
          <div :class="brandClasses.grid">
            <section v-if="$feature.configExternalApps.productCompareUrl" class="lg:col-span-8 md:col-span-7 md:row-start-1 md:row-end-3 md:pt-4 <md:-mx-2">
              <div
                id="pdp-compare-app"
                data-category="jacket"
                :data-sku="productId.slice(3)"
                :data-view="formattedLocale"
                @open-quickshop="openQuickshop"
              />
            </section>
            <slot name="shop-the-look" />
            <section :class="[brandClasses.eSpotsAndReviews, $feature.showFullscreenGridOnPDP ? brandClasses.gridFullWidth : brandClasses.gridPartialWidth]">
              <slot name="espot-lazy-below-gallery" />
              <slot name="reviews" />
            </section>
          </div>
        </div>
      </transition>
      <slot name="recommendations" />
    </div>
    <slot name="espot-lazy-above-footer" />
    <client-only>
      <teleport to="body">
        <slot name="body" />
      </teleport>
    </client-only>
    <slot />
  </main>
</template>

<script setup lang="ts">
import type { Slots } from '#commerce/types/pdp'

defineSlots<Slots>()

const { brandClasses } = useAppConfig().pages?.pdp || {}
const formattedLocale = useFormattedLocale()
const header = useHeaderStore()
const { $t } = useNuxtApp()
const { openQuickshop, product, productId, productPending } = usePdp()

const sizingMessage = computed(() => product.value?.sizeChart && $t.sizingMessages?.[product.value.sizeChart])
</script>
